const state = {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    userVips:localStorage.getItem('userVip') || null,
}

const mutations = {
    SET_USER_INFO(state, info) {
        state.userInfo = info
        localStorage.setItem('userInfo', JSON.stringify(info))
    },
    // 设置城市
    SET_USER_CITY(state, info) {
        state.userInfo = {
            ...(state.userInfo || {}),
            city_id: info.id
        }
        localStorage.setItem(
            'userInfo',
            JSON.stringify(state.userInfo)
        )
    },
    // 设置车型
    SET_USER_CARTYPE(state, info) {
        state.userInfo = {
            ...(state.userInfo || {}),
            car_type_id: info.car_type_id,
            car_type_signs: info.signs,
            car_category: info.car_category
        }
        localStorage.setItem(
            'userInfo',
            JSON.stringify(state.userInfo)
        )
    },
    // 设置科目
    SET_USER_SUBJECT(state, info) {
        state.userInfo = {
            ...(state.userInfo || {}),
            subject_id: info.subject_id
        }
        localStorage.setItem(
            'userInfo',
            JSON.stringify(state.userInfo)
        )
    },
    // 设置会员权限
    SET_USER_VIP(state, info) {
        state.userVips = info
        localStorage.setItem(
            'userVip',
            state.userVips
        )
    },
    LOGOUT(state) {
        state.userInfo = null
        localStorage.removeItem('userInfo')
    }
}

const actions = {
    saveUser({ commit }, info) {
        commit('SET_USER_INFO', info)
    },
    // 设置城市
    setCity({ commit }, info) {
        commit('SET_USER_CITY', info)
    },
    // 设置车型
    setCar({ commit }, info) {
        commit('SET_USER_CARTYPE', info)
    },
    // 设置科目
    setSubject({ commit }, info) {
        if (state.userInfo) {
            commit('SET_USER_SUBJECT', info)
        }
    },
    // 设置会员权限
    setUserVip({ commit }, info) {
        commit('SET_USER_VIP', info)
    },
    logout({ commit }) {
        commit('LOGOUT')
    }
}

export default {
    namespaced: true, // ⭐ 强烈建议
    state,
    mutations,
    actions
}
